/**
 * @generated SignedSource<<b529c3eb66d874d5de44fc20df07b773>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineDetailScreenTaskIssueRefetch$variables = {
  fromDate?: string | null;
  id: string;
};
export type RoutineDetailScreenTaskIssueRefetch$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"RoutineDetailScreenTopTaskIssueCreator_Routine">;
  } | null;
};
export type RoutineDetailScreenTaskIssueRefetch = {
  response: RoutineDetailScreenTaskIssueRefetch$data;
  variables: RoutineDetailScreenTaskIssueRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fromDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineDetailScreenTaskIssueRefetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineDetailScreenTopTaskIssueCreator_Routine"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineDetailScreenTaskIssueRefetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "fromDate",
                    "variableName": "fromDate"
                  }
                ],
                "concreteType": "TaskSectionIssueStatNode",
                "kind": "LinkedField",
                "name": "topTaskSectionIssueCreators",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Routine",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82067e7a63053bf2bce32120dddf5251",
    "id": null,
    "metadata": {},
    "name": "RoutineDetailScreenTaskIssueRefetch",
    "operationKind": "query",
    "text": "query RoutineDetailScreenTaskIssueRefetch(\n  $fromDate: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...RoutineDetailScreenTopTaskIssueCreator_Routine\n    id\n  }\n}\n\nfragment RoutineDetailScreenTopTaskIssueCreator_Routine on Routine {\n  topTaskSectionIssueCreators(fromDate: $fromDate) {\n    id\n    section {\n      id\n      title\n      assignedTeam {\n        id\n        icon\n        name\n      }\n    }\n    count\n    task {\n      __typename\n      id\n      title\n      ... on TaskCheck {\n        __typename\n      }\n      ... on TaskNumber {\n        __typename\n      }\n      ... on TaskText {\n        __typename\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "e95669fa7e4a6b7b5c7c76150649180b";

export default node;
